module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d5b338"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oldRoutes.vue
// module id = 736
// module chunks = 0